import { render } from "./AmountInputFormated.vue?vue&type=template&id=eec0f1fa"
import script from "./AmountInputFormated.vue?vue&type=script&lang=js"
export * from "./AmountInputFormated.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__